import { API } from '@/api/Api'

import { ActiveEveAnalysisQuery } from '@/api/query/Risks.graphql'

export default {
  // Queries
  async ActiveEveAnalysis (accountId, analysisId) {
    const Data = { accountId: accountId }

    // Only add analysisId if it's provided
    if (analysisId) {
      Data.analysisId = analysisId
    }

    return await API.GQLRequest(ActiveEveAnalysisQuery, Data)
  }
}
